function deleteCallContextMenu() {
    $('.tabs-list-link, .tags-list-link, .menu-btn').on('contextmenu', function (e) {
        return false;
    })
}

function switchStateOfPostsLink(isEnabled) {
    var successStoriesPostsLinks = document.querySelectorAll('.success-stories-list__item-link');
    for (var i = 0; i < successStoriesPostsLinks.length; i++) {
        $(successStoriesPostsLinks[i]).off('click');
        $(successStoriesPostsLinks[i]).on('click', function () {
            if (isEnabled) {
                window.location.href = this.href
            } else {
                return isEnabled;
            }
        });
    }
}

function showCardPreview() {
    var container = document.querySelector('.success-stories-list');
    var successStoriesListItems = document.querySelectorAll('.success-stories-list__item');
    switchStateOfPostsLink(true);

    $(container).on('touchstart', function (event) {
        var screenWidth = window.innerWidth;
        var element = event.target;
        if (element.classList.contains('stories-img') ||
            (element.classList.contains('success-stories-list__item-content')) ||
            (element.classList.contains('btn-group'))) {
            setTimeout(function () {
                switchStateOfPostsLink(false);
            })
            console.log(screenWidth)
            var cardContentElement = event.target.closest('.success-stories-list__item');
            successStoriesListItems.forEach(function (element, index) {
                if (element === cardContentElement) {
                    setTimeout(function () {
                        switchStateOfPostsLink(true);
                    }, 250);
                }
            })
        } else if (element.classList.contains('js-link')
            || (element.classList.contains('success-stories-list__item-content-inner'))
            || (element.classList.contains('posts-list__btn'))
            || (element.classList.contains('success-stories-list__item-link'))
            || (element.classList.contains('success-stories-list__item-arrow-wrapper'))
            || (element.classList.contains('js-img'))) {
            return;
        } else {
            setTimeout(function () {
                switchStateOfPostsLink(false);
            })
        }
    })
}

function addClampOfText(titleLines, textLines){
    var successStoriesListItems = document.querySelectorAll('.success-stories-list__item');
    var successPostTitles = document.querySelectorAll('.success-stories-list__item-title');
    var successPostTextItems = document.querySelectorAll('.success-stories-list__item-text');
    for (var i = 0; i < successStoriesListItems.length; i++) {
        //$(successStoriesListItems[i]).on('mouseenter', function(){
            truncatePostContent(successPostTitles, successPostTextItems, titleLines, textLines);
        //})
    }
}
function equalizeChildHeights() {
    const children = document.querySelectorAll('.success-stories-list__item-title');
    let maxHeight = 0;

    children.forEach(el => {
        el.style.height = 'auto';
    });

    children.forEach(el => {
        maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    children.forEach(el => {
        el.style.height = maxHeight + 'px';
    });
}



$(document).ready(function () {
    deleteCallContextMenu();
    showCardPreview();
    window.addEventListener('load', equalizeChildHeights);
    window.addEventListener('resize', equalizeChildHeights);
})